export default __webpack_public_path__ + "static/fullWidthRows-ede9cb1923fc1f9dca2f5d9ca7600820.gif";